const events = {
  FETCH_SNS_TEMPLATE_DATA_PROGRESS: 'sns/fetch_data_progress',
  FETCH_SNS_TEMPLATE_DATA_SUCCESS: 'sns/fetch_data_success',
  FETCH_SNS_TEMPLATE_DATA_NOT_FOUND: 'sns/fetch_data_not_found',
  FETCH_SNS_TEMPLATE_DATA_FAILED: 'sns/fetch_data_failed',
};
export default events;
